import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { Component, createRef } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { Dropdown } from '@wordpress/components';
import PropTypes from 'prop-types';
/**
 * Internal dependencies
 */

import DatePickerContent from './content';
import DropdownButton from '../dropdown-button';

var shortDateFormat = __('MM/DD/YYYY', 'woocommerce-admin');
/**
 * Select a range of dates or single dates.
 */


var DateRangeFilterPicker =
/*#__PURE__*/
function (_Component) {
  _inherits(DateRangeFilterPicker, _Component);

  function DateRangeFilterPicker(props) {
    var _this;

    _classCallCheck(this, DateRangeFilterPicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateRangeFilterPicker).call(this, props));
    _this.state = _this.getResetState();
    _this.dropdownRef = createRef();
    _this.update = _this.update.bind(_assertThisInitialized(_this));
    _this.onSelect = _this.onSelect.bind(_assertThisInitialized(_this));
    _this.isValidSelection = _this.isValidSelection.bind(_assertThisInitialized(_this));
    _this.resetCustomValues = _this.resetCustomValues.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DateRangeFilterPicker, [{
    key: "formatDate",
    value: function formatDate(date, format) {
      if (date && date._isAMomentObject && 'function' === typeof date.format) {
        return date.format(format);
      }

      return '';
    }
  }, {
    key: "getResetState",
    value: function getResetState() {
      var _this$props$dateQuery = this.props.dateQuery,
          period = _this$props$dateQuery.period,
          compare = _this$props$dateQuery.compare,
          before = _this$props$dateQuery.before,
          after = _this$props$dateQuery.after;
      return {
        period: period,
        compare: compare,
        before: before,
        after: after,
        focusedInput: 'startDate',
        afterText: this.formatDate(after, shortDateFormat),
        beforeText: this.formatDate(before, shortDateFormat),
        afterError: null,
        beforeError: null
      };
    }
  }, {
    key: "update",
    value: function update(_update) {
      this.setState(_update);
    }
  }, {
    key: "onSelect",
    value: function onSelect(selectedTab, onClose) {
      var _this2 = this;

      var _this$props = this.props,
          isoDateFormat = _this$props.isoDateFormat,
          onRangeSelect = _this$props.onRangeSelect;
      return function (event) {
        var _this2$state = _this2.state,
            period = _this2$state.period,
            compare = _this2$state.compare,
            after = _this2$state.after,
            before = _this2$state.before;
        var data = {
          period: 'custom' === selectedTab ? 'custom' : period,
          compare: compare
        };

        if ('custom' === selectedTab) {
          data.after = _this2.formatDate(after, isoDateFormat);
          data.before = _this2.formatDate(before, isoDateFormat);
        } else {
          data.after = undefined;
          data.before = undefined;
        }

        onRangeSelect(data);
        onClose(event);
      };
    }
  }, {
    key: "getButtonLabel",
    value: function getButtonLabel() {
      var _this$props$dateQuery2 = this.props.dateQuery,
          primaryDate = _this$props$dateQuery2.primaryDate,
          secondaryDate = _this$props$dateQuery2.secondaryDate;
      return ["".concat(primaryDate.label, " (").concat(primaryDate.range, ")"), "".concat(__('vs.', 'woocommerce-admin'), " ").concat(secondaryDate.label, " (").concat(secondaryDate.range, ")")];
    }
  }, {
    key: "isValidSelection",
    value: function isValidSelection(selectedTab) {
      var _this$state = this.state,
          compare = _this$state.compare,
          after = _this$state.after,
          before = _this$state.before;

      if ('custom' === selectedTab) {
        return compare && after && before;
      }

      return true;
    }
  }, {
    key: "resetCustomValues",
    value: function resetCustomValues() {
      this.setState({
        after: null,
        before: null,
        focusedInput: 'startDate',
        afterText: '',
        beforeText: '',
        afterError: null,
        beforeError: null
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state2 = this.state,
          period = _this$state2.period,
          compare = _this$state2.compare,
          after = _this$state2.after,
          before = _this$state2.before,
          focusedInput = _this$state2.focusedInput,
          afterText = _this$state2.afterText,
          beforeText = _this$state2.beforeText,
          afterError = _this$state2.afterError,
          beforeError = _this$state2.beforeError;
      return createElement("div", {
        className: "woocommerce-filters-filter"
      }, createElement("span", {
        className: "woocommerce-filters-label"
      }, __('Date Range', 'woocommerce-admin'), ":"), createElement(Dropdown, {
        ref: this.dropdownRef,
        contentClassName: "woocommerce-filters-date__content",
        position: "bottom",
        expandOnMobile: true,
        renderToggle: function renderToggle(_ref) {
          var isOpen = _ref.isOpen,
              onToggle = _ref.onToggle;
          return createElement(DropdownButton, {
            onClick: onToggle,
            isOpen: isOpen,
            labels: _this3.getButtonLabel()
          });
        },
        renderContent: function renderContent(_ref2) {
          var onClose = _ref2.onClose;
          return createElement(DatePickerContent, {
            period: period,
            compare: compare,
            after: after,
            before: before,
            onUpdate: _this3.update,
            onClose: onClose,
            onSelect: _this3.onSelect,
            isValidSelection: _this3.isValidSelection,
            resetCustomValues: _this3.resetCustomValues,
            focusedInput: focusedInput,
            afterText: afterText,
            beforeText: beforeText,
            afterError: afterError,
            beforeError: beforeError,
            shortDateFormat: shortDateFormat
          });
        }
      }));
    }
  }]);

  return DateRangeFilterPicker;
}(Component);

DateRangeFilterPicker.propTypes = {
  /**
   * Callback called when selection is made.
   */
  onRangeSelect: PropTypes.func.isRequired,

  /**
   * The date query string represented in object form.
   */
  dateQuery: PropTypes.shape({
    period: PropTypes.string.isRequired,
    compare: PropTypes.string.isRequired,
    before: PropTypes.object,
    after: PropTypes.object,
    primaryDate: PropTypes.shape({
      label: PropTypes.string.isRequired,
      range: PropTypes.string.isRequired
    }).isRequired,
    secondaryDate: PropTypes.shape({
      label: PropTypes.string.isRequired,
      range: PropTypes.string.isRequired
    }).isRequired
  }).isRequired
};
export default DateRangeFilterPicker;
//# sourceMappingURL=index.js.map